import React, { useEffect, useState } from 'react';
import { Container } from 'components/Page';
import { Formik, Field, Form } from 'formik';
import { api } from 'app';
import BaseAlert from 'packages/ui/Alert';
import { FormGroup, FormControl, Label } from '../../../components/form/Formik';
import { DatePicker } from 'jalali-react-datepicker';
import Button from 'packages/ui/Button';
import moment from 'moment-jalali';

export default ({ eventId, eventSlug }) => {
  const [submittingMsg, setSubmittingMsg] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    partnership: '',
    admin_rating: '',
    request_deposit: '',
    cash_commission: '',
    percent_commission: '',
    commission_description: '',
    start_date: '',
    end_date: ''
  });
  const [showTimes, setShowTimes] = useState();
  moment.loadPersian();

  useEffect(() => {
    api.get(`adminPanel/events/${eventId}`).then(res => {
      setStartDate(moment(res.body.data.start_date));
      setEndDate(moment(res.body.data.end_date));
      res.body.data.partnership = res.body.data.partnership.status;
      setData(res.body.data);
      setLoading(false);
    });

    api.get(`events/${eventSlug}/showtimes`).then(res => {
      setShowTimes(res.body.data);
    });
  }, []);
  return (
    <Container>
      <div>
        <h1>فرم تنظیمات رویداد</h1>
        {!loading && (
          <Formik
            initialValues={data}
            onSubmit={async (values, actions) => {
              actions.setSubmitting(true);
              values.start_date = startDate;
              values.end_date = endDate;

              api
                .put(`adminPanel/events/${eventId}`, { ...values })
                .then(() => {
                  api
                    .put(`events/${eventSlug}/showtimes/${showTimes[0].id}`, {
                      start_date: typeof startDate === 'object' ? startDate._i : startDate,
                      end_date: typeof endDate === 'object' ? endDate._i : endDate,
                      id: showTimes[0].id,
                      sendNotification: false
                    })
                    .then(() => {
                      setSubmittingMsg('درخواست شما با موفقیت ثبت گردید.');
                    });
                })
                .catch(err => {
                  setSubmittingMsg(Object.values(err.errors)[0][0]);
                })
                .finally(() => {
                  actions.setSubmitting(false);
                });
            }}
          >
            {({ values }) => {
              return (
                <Form>
                  <FormGroup>
                    <FormControl>
                      <Label htmlFor="request_deposit">درخواست تسویه</Label>
                      <Field as="select" name="request_deposit">
                        <option disabled value="">
                          انتخاب کنید ...
                        </option>
                        <option value="yes">بله</option>
                        <option value="no">خیر</option>
                      </Field>
                    </FormControl>
                    <FormControl>
                      <Label htmlFor="partnership">وضعیت رویداد</Label>
                      <Field as="select" name="partnership">
                        <option disabled value="">
                          انتخاب کنید ...
                        </option>
                        <option value="colleague">همکار</option>
                        <option value="partner">همیار</option>
                        <option value="">عادی</option>
                      </Field>
                    </FormControl>
                  </FormGroup>
                  <FormGroup>
                    <FormControl>
                      <Label htmlFor="percent_commission">کارمزد درصدی ایوند</Label>
                      <Field id="percent_commission" name="percent_commission" type="number" />
                    </FormControl>
                    <FormControl>
                      <Label htmlFor="cash_commission">کارمزد نقدی ایوند</Label>
                      <Field id="cash_commission" name="cash_commission" type="number" />
                    </FormControl>
                  </FormGroup>
                  <FormGroup>
                    <FormControl>
                      <Label htmlFor="commission_description">نوت برای کارمزد ایوند</Label>
                      <Field
                        id="commission_description"
                        name="commission_description"
                        type="text"
                      />
                    </FormControl>
                    <FormControl>
                      <Label htmlFor="admin_rating">Admin Rate: </Label>
                      <Field as="select" name="admin_rating">
                        <option disabled value="">
                          انتخاب کنید ...
                        </option>
                        <option value="good">خوب</option>
                        <option value="normal">معمولی</option>
                        <option value="bad">ضعیف</option>
                      </Field>
                    </FormControl>
                  </FormGroup>
                  <FormGroup>
                    <FormControl>
                      <Label htmlFor="start_date">تاریخ و ساعت شروع</Label>
                      <DatePicker
                        value={startDate}
                        onClickSubmitButton={e => {
                          var dateStringWithTime = moment(e.value._d)
                            .locale('fa')
                            .format('YYYY-MM-DD H:m:ss');
                          setStartDate(dateStringWithTime);
                        }}
                      />
                    </FormControl>
                    <FormControl>
                      <Label htmlFor="end_date">تاریخ و ساعت پایان</Label>
                      <DatePicker
                        value={endDate}
                        onClickSubmitButton={e => {
                          var dateStringWithTime = moment(e.value._d)
                            .locale('fa')
                            .format('YYYY-MM-DD H:m:ss');
                          setEndDate(dateStringWithTime);
                        }}
                      />
                    </FormControl>
                  </FormGroup>
                  <Button type="submit">ذخیره</Button>

                  {submittingMsg && (
                    <BaseAlert mood="info" title={submittingMsg}>
                      {submittingMsg}
                    </BaseAlert>
                  )}
                </Form>
              );
            }}
          </Formik>
        )}
      </div>
    </Container>
  );
};
